import { render } from "./ViewAdminPrecios.vue?vue&type=template&id=6b5505b6"
import script from "./ViewAdminPrecios.vue?vue&type=script&lang=js"
export * from "./ViewAdminPrecios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__